import { Dirtiness } from '../types/dirtiness';

export const isDirtinessDirty = <T extends Dirtiness<{}>>(dirtiness: T) => {
    return Object.values(dirtiness).some(Boolean);
};
